export const classnames = (...classes: string[]) =>
  classes.filter(Boolean).join(' ')
